import FavoritesPopoverInteractionPage from "@faire/prototype-playground/workspace/cr/favorites-popover-interaction";
import { Route, Switch } from "react-router-dom";

export function ChrisRodriguezRoutes() {
  return (
    <Switch>
      <Route
        path="/cr/favorites-popover-interaction"
        component={FavoritesPopoverInteractionPage}
      />
    </Switch>
  );
}

export const slug = "cr";
